import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Button,
  Paper,
  Alert
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';

const SubscriptionCancel: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        p: 3
      }}
    >
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          width: '100%', 
          maxWidth: 500,
          textAlign: 'center',
          borderRadius: 2
        }}
      >
        <CancelIcon color="error" sx={{ fontSize: 64, mb: 2 }} />
        <Typography variant="h4" gutterBottom>Payment Canceled</Typography>
        
        <Alert severity="info" sx={{ mb: 3, mt: 2 }}>
          Your subscription payment process was canceled. No charges were made.
        </Alert>
        
        <Typography variant="body1" paragraph>
          You can try again or select a different subscription plan whenever you're ready.
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', mt: 3 }}>
          <Button 
            variant="outlined" 
            onClick={() => navigate('/dashboard')}
          >
            Back to Dashboard
          </Button>
          <Button 
            variant="contained" 
            color="primary" 
            onClick={() => navigate('/organization/subscription')}
          >
            View Plans
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default SubscriptionCancel;
